module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAoBAMAAABKqWRCAAAALVBMVEUAAAD/gID/VUz/W1L/V03/Vkz/Vk3/WEz/Vk3/VU3/VU3/Vk3/Vk3/Vk3/Vk2ays7JAAAADnRSTlMAAhscSYKFhtPU2tv4+fEtgQ4AAAB0SURBVCjPY2CgFDDikvBQwC7Ocm4Rdgmfd6+wamG59+4dVi2s797h0FL3DocWdrpoYcOpJY9sLe+wAqAW7BJALTgkXuGSeI1LYjMuyw1wOHcxLg8OEQ11ODSw4tIASqKLsSZqX+waQFoW48g4ngakZjXCAAAr1uCSQchBswAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/program_jump_icon_small@2x.png
// module id = ofPd
// module chunks = 0